// src/theme.ts
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
// Load the weights you actually use (keeps bundle small)
import "@fontsource/ubuntu/300.css";
import "@fontsource/ubuntu/400.css";
import "@fontsource/ubuntu/500.css";
import "@fontsource/ubuntu/700.css";

let theme = createTheme({
  typography: {
    fontFamily: '"Ubuntu", "Helvetica", "Arial", sans-serif',
    // optional: tighten headings a bit
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    button: { textTransform: "none", fontWeight: 600 }, // brand look
  },
  // (optional) anything else: palette, shape, etc.
});

// scale typographic sizes nicely across breakpoints
theme = responsiveFontSizes(theme);

export default theme;
